import { Form } from '@kanda-libs/ks-component-ts';
import { Button, Text } from '@kanda-libs/ks-design-library';

import AcceptTermsInput from 'components/AcceptTermsInput';
import CheckList from 'components/CheckList';
import CheckListElement from 'components/CheckListElement';

import {
  CHECKS_PROPS,
  CHECKS_TITLE_PROPS,
  LIST_TITLE_PROPS,
  TITLE_PROPS,
} from './constants';
import useApplyTermsAndConditionsForm from './useApplyTermsAndConditions';

import ApplyCard from '../components/Card';

const ApplyTermsAndConditions: React.FunctionComponent = function () {
  const { form, onSubmit, disabled, listProps, isLoading } =
    useApplyTermsAndConditionsForm();
  return (
    <Form id="apply-terms-and-conditions" form={form} onSubmit={onSubmit}>
      <ApplyCard>
        <Text {...TITLE_PROPS} isLoading={isLoading} />
        <Text {...CHECKS_TITLE_PROPS} isLoading={isLoading} />
        <CheckList {...CHECKS_PROPS} isLoading={isLoading} />
        <Text {...LIST_TITLE_PROPS} isLoading={isLoading} />
        <CheckListElement {...listProps} isLoading={isLoading} />
        <AcceptTermsInput
          name="acceptTermsAndConditions"
          label="I have read the above terms and conditions and agree to them, as well as "
          linkLabel="Ideal4Finance's General Terms & Conditions"
        />
        <Button.Text
          id="apply-terms-and-conditions-next"
          label="Continue"
          icon="arrow-right"
          variant="gradient"
          disabled={disabled || isLoading}
          isLoading={isLoading}
          submit
        />
      </ApplyCard>
    </Form>
  );
};

export default ApplyTermsAndConditions;
